import { isString } from '@aloft/toolkit-shared';
import { Block, Button, Flex, IconButton, Typography } from '@aloft/toolkit-sui';

import { ToastOptions } from './types.ts';

export function RenderToast({
  title,
  body,
  onClose,
  action,
}: {
  title: ToastOptions['title'];
  body: ToastOptions['body'];
  onClose: VoidFunction;
  action?: {
    text: string;
    onClick: () => void;
  };
}) {
  const paragraphs = Array.isArray(body) ? body : isString(body) ? [body] : [];
  return (
    <Flex alignItems="center">
      <Block flex={1}>
        <Typography variant="h4" __dangerDoNotUseSx={{ marginBottom: 1 }}>
          {title}
        </Typography>
        <Flex alignItems="flex-end">
          {paragraphs.map((x) => (
            <Typography key={x}>{x}</Typography>
          ))}
          {action && <Button text={action.text} onClick={action.onClick} marginLeft="1.5rem" />}
        </Flex>
      </Block>
      <Block alignSelf="flex-start">
        <IconButton
          variant="tertiary"
          icon="close"
          size="xs"
          onClick={onClose}
          ariaLabel="Close alert"
          __dangerDoNotUseSx={{ marginLeft: 2 }}
        />
      </Block>
    </Flex>
  );
}
